import type { Capture, CaptureType, MeetingContext } from "./schema";

export interface BuildCaptureInput {
  id: string;
  createdBy: string;
  projectId: string;
  type: CaptureType;
  title: string | null;
  durationMs: number;
  audioUri: string | null;
  keepAudio: boolean;
  startedAt: Date;
  now: Date;
  meetingContext?: MeetingContext | null;
  // Step 11 Palier 2 — false = extract sync immédiat ; true (défaut) = batch
  // OpenAI à -50 % coût, livraison ~6-24h via process-llm-batch cron.
  batchExtraction?: boolean;
  // Anti-perte : durée d'horloge de la prise (s) et audio illisible estimé (ms).
  // Portés seulement quand fournis : les appelants existants ne changent pas.
  elapsedS?: number | null;
  missingAudioMs?: number | null;
}

export function buildCapture(input: BuildCaptureInput): Capture {
  const isoNow = input.now.toISOString();
  return {
    id: input.id,
    createdBy: input.createdBy,
    projectId: input.projectId,
    type: input.type,
    title: input.title,
    recordedAt: input.startedAt.toISOString(),
    // Clamp >= 0 : une durée native aberrante (ex. AVAudioRecorder.currentTime
    // négatif après un changement de route AirPods) ne doit jamais produire une
    // capture invalide — le schéma exige durationS nonnegative et la contrainte
    // DB captures_duration_s_check rejette une durée négative (échec synchro).
    durationS: Math.max(0, Math.floor(input.durationMs / 1000)),
    audioPath: input.keepAudio ? input.audioUri : null,
    keepAudio: input.keepAudio,
    status: "uploading",
    transcriptRaw: null,
    transcriptSegments: null,
    summary: null,
    gist: null,
    errorMessage: null,
    ...(input.elapsedS !== undefined ? { elapsedS: input.elapsedS } : {}),
    ...(input.missingAudioMs !== undefined ? { missingAudioMs: input.missingAudioMs } : {}),
    meetingContext: input.meetingContext ?? null,
    batchExtraction: input.batchExtraction ?? true,
    approvedAt: null,
    approvedBy: null,
    createdAt: isoNow,
    updatedAt: isoNow,
  };
}
